// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__1LT76","header":"PatientQuestionnaire_header__BNUOp","info":"PatientQuestionnaire_info__1SIhU"};